import React, { useState } from 'react';
import { useAppDispatch } from 'hooks';
import classNames from 'classnames';

import { Button } from '~components';
import Icon, { faPlus } from '~components/icon';
import FileOffCanvas from '~support-at-home/components/common/FileOffCanvas';

import { uploadInvoiceFile } from '~support-at-home/actions/supplierInvoices';

import SupplierInvoiceModal from './SupplierInvoiceModal';

interface ComponentProps {
  authTag?: string;
  load?: () => void;
}

const AddSupplierInvoiceButton: React.FC<ComponentProps> = ({ authTag, load }) => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [isFileCanvasCollapsed, setIsFileCanvasCollapsed] = useState<boolean>(false);
  const [file, setFile] = useState<File | undefined>();
  const dispatch = useAppDispatch();

  const onClose = (confirm: boolean, id?: string) => {
    setModalOpen(false);

    if (confirm && file && id) {
      dispatch(uploadInvoiceFile({ file, id }));
    }
    setFile(undefined);
    load?.();
  };

  const modalClassName = classNames({
    'full-view': isFileCanvasCollapsed,
  });

  return (
    <>
      <Button onClick={() => setModalOpen(true)} size="sm" color="success" authTag={authTag}>
        <Icon className="me-2" icon={faPlus} />
        New Invoice
      </Button>
      <SupplierInvoiceModal
        className={modalClassName}
        isOpen={isModalOpen}
        onClose={onClose}
        isNew={true}
        authTag={authTag}
      />
      <FileOffCanvas
        isOpen={isModalOpen}
        onChange={(file) => setFile(file)}
        onToggleCollapse={setIsFileCanvasCollapsed}
        selectorFiles={[]}
      />
    </>
  );
};

export default AddSupplierInvoiceButton;
